// Update query without reloading the current page
export function addParamsToLocation(params, route) {
  history.pushState({},
    null,
    route.path +
    '?' +
    Object.keys(params)
    .map(key => {
      return (
        encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
      )
    })
    .join('&')
  )
}